import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-tools-section',
  templateUrl: './tools-section.component.html',
  styleUrls: ['./tools-section.component.scss'],
})
export class ToolsSectionComponent implements AfterViewInit {
  @ViewChild('toolsVideo') toolsVideo?: ElementRef<HTMLVideoElement>;

  showFallbackImage = false;
  isVideoReady = false;
  isMuted = true;

  ngAfterViewInit(): void {
    const video = this.toolsVideo?.nativeElement;
    if (!video) {
      this.onVideoError();
      return;
    }

    video.muted = this.isMuted;
  }

  onVideoReady(): void {
    this.isVideoReady = true;
  }

  onVideoError(): void {
    this.showFallbackImage = true;
    this.isVideoReady = false;
  }

  switchSound(): void {
    const video = this.toolsVideo?.nativeElement;
    if (!video) return;

    video.muted = !video.muted;
    this.isMuted = video.muted;
  }
}
